module.exports = __webpack_public_path__ + "img/Jump Casting97.10ef7530.jpg";